import React from 'react'

import withStyles from '@material-ui/core/styles/withStyles'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import T from 'components/FormattedMessage'

import whistle from './assets/whistle.svg'
import { createStyles, WithStyles, Theme } from '@material-ui/core'

const styles = (theme: Theme) => createStyles({
  root: {
    paddingTop: theme.spacing() * 2,
    paddingBottom: theme.spacing() * 2,
  },
  line: {
    width: 1,
    height: 128,
    backgroundColor: theme.palette.divider
  }
})

type InjectedProps = WithStyles<typeof styles>

const TimelineEmptyState: React.SFC<InjectedProps> = ({ classes }) => (
  <Grid className={classes.root} spacing={2} alignItems="center" direction="column" container>
    <Grid item>
      <img src={whistle} alt="whistle" />
    </Grid>
    <Grid className="" item>
      <Typography align="center" variant="h4">
        <T id="gamedetails_timeline_empty_title" />
      </Typography>
      <Typography align="center">
        <T id="gamedetails_timeline_empty_message" />
      </Typography>
    </Grid>
    <Grid item>
      <div className={classes.line} />
    </Grid>
  </Grid>
)

export default withStyles(styles)(TimelineEmptyState)
